import React from 'react';
import uniqid from 'uniqid';

import { StudentDetails } from '../StudentProgressDetails';

const createStudentAnswerTipsDetails = (
  studentsNotStarted = [],
  studentsNotSubmitted = [],
  studentsSubmitted = [],
  forPartsAndTips = false,
) => {
  const studentsWhoHaveNotStarted = [];
  const studentsWhoHaveNotSubmitted = [];
  const studentsWhoHaveSubmitted = [];

  studentsNotStarted.forEach((student) => {
    const { first_name: firstName, last_name: lastName } = student || {};
    studentsWhoHaveNotStarted.push(
      <StudentDetails
        key={uniqid()}
        firstName={firstName}
        lastName={lastName}
        showProgressPercentage={false}
      />,
    );
  });
  studentsNotSubmitted.forEach((student) => {
    const {
      first_name: firstName,
      last_name: lastName,
      studentWithProgress: progressPercentage,
    } = student || {};
    studentsWhoHaveNotSubmitted.push(
      <StudentDetails
        key={uniqid()}
        firstName={firstName}
        lastName={lastName}
        progressPercentage={progressPercentage}
        showProgressPercentage
        forPartsAndTips={forPartsAndTips}
      />,
    );
  });
  studentsSubmitted.forEach((student) => {
    const {
      first_name: firstName,
      last_name: lastName,
      studentWithProgress: progressPercentage,
    } = student || {};
    studentsWhoHaveSubmitted.push(
      <StudentDetails
        key={uniqid()}
        firstName={firstName}
        lastName={lastName}
        progressPercentage={progressPercentage}
        showProgressPercentage
        forPartsAndTips={forPartsAndTips}
      />,
    );
  });

  return {
    studentsWhoHaveNotStarted,
    studentsWhoHaveNotSubmitted,
    studentsWhoHaveSubmitted,
  };
};

export default createStudentAnswerTipsDetails;
